import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import {
  BackendService,
  TableSettings,
  FieldStructure,
  NotificationService,
  ListService,
} from 'beyond-util';
import { ReportService } from '../../../services/report.service';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import * as moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '../../../constants/date-format';
import { MimeFileType } from '../../../enums/mime-file-type.enum';
import { UtilServiceClient } from '../../../services/util.service';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { RequestTypeEnum } from '../../../enums/request-type.enum';

@Component({
  selector: 'app-izvestaj-za-sokoj',
  templateUrl: './izvestaj-za-sokoj.component.html',
  styleUrls: ['./izvestaj-za-sokoj.component.scss'],
})
export class IzvestajZaSokojComponent extends IzvestajBaseComponent
  implements OnInit {
  public canGenerate = true;
  report: any = {};

  constructor(
    protected _backendService: BackendService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    protected _rtsBackendService: RtsBackendService,
    protected _listService: ListService,
    protected utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService);
    this._spinner.show();
    this.getSettings();
    this.name = 'Izveštaj za SOKOJ';
  }

  ngOnInit() {
    super.ngOnInit();
    this.orderList = [];
    this.report = {
      DatumOd: new Date(),
      DatumDo: new Date(),
      ProgramIds: [],
    };
  }

  getSettings() {
    const req = this.reportService.getSettingsPayload(
      ReportNameEnum.SOKOJ,
      EndpointTypeEnum.Settings,
      FormCode.MSIZV_SOKOJ
    );

    this.reportService.getSettings(req).subscribe(s => {
      this.splitDetails(s);
      this.fetchProgrami();
      this._listService.enumItemsSet.subscribe(prog => {
        this.fieldStructure = new FieldStructure(s, 'header');
        this.settingsTable = new TableSettings(s.details[0], 'table');
        this.settingsTableSource.next(this.settingsTable);
        this._spinner.hide();
      });
    });
    this._spinner.hide();
  }

  fetchProgrami() {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSPRO_PRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .subscribe(response => {
        const programi = response.ServiceData.Data;
        const parsed = this.utilService.parseEnum(programi);
        this._listService.registerEnum('MSIZV_SOKOJ_ProgramIdsEnum', parsed);
        this._spinner.hide();
      });
  }

  onReportValueChanged(event) {
    if (event) {
      switch (event.fieldMap.fieldKey) {
        case 'datumOd':
          this.canGenerate = false;
          break;
        case 'datumDo':
          this.canGenerate = false;
          break;
      }
    }
  }

  refresh() {
    this.report = {
      DatumOd: new Date(),
      DatumDo: new Date(),
      ProgramIds: [],
    };

    this.orderList = [];
    this.documentListSource.next(this.orderList);
  }

  settingsLoadSingle() {}

  getFilterString(): string {
    return `?datumOd=${moment(this.report.DatumOd).format(
      DEFAULT_DATE_FORMAT
    )}&datumDo=${moment(this.report.DatumDo).format(DEFAULT_DATE_FORMAT)}`;
  }

  filter() {
    if (this.report.ProgramIds && this.report.ProgramIds.length < 1) {
      this.notificationService.notyError(
        'Potrebno je odabrati bar jedan program.'
      );

      return;
    }

    if (moment(this.report.DatumOd).isAfter(moment(this.report.DatumDo))) {
      this.notificationService.notyError('Zadati period datuma nije validan.');

      return;
    }

    const entity = {
      DatumOd: moment(this.report.DatumOd).format(DEFAULT_DATE_FORMAT),
      DatumDo: moment(this.report.DatumDo).format(DEFAULT_DATE_FORMAT),
      ProgramIds: this.report.ProgramIds,
    };

    this._spinner.show();
    this.reportService
      .getFormData(
        this.reportService.getPayload(
          '',
          entity,
          FormCode.MSIZV_SOKOJ,
          ReportNameEnum.SOKOJ,
          EndpointTypeEnum.Form,
          RequestTypeEnum.Post
        )
      )
      .subscribe((data: any) => {
        this._spinner.hide();
        this.orderList = this.getResponseData(data);
        if (!(this.orderList.length > 0)) {
          this.notificationService.notyError(
            'Ne postoji ni jedna verifikovana stavka za zadati period datuma.'
          );

          this.canGenerate = false;
        } else {
          this.canGenerate = true;
        }
        this.documentListSource.next(this.orderList);
      });
  }

  onToolbarActionExport() {
    if (!this.orderList.length) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const payload = this.reportService.getPayload(
      this.getFilterString(),
      this.orderList,
      FormCode.MSIZV_SOKOJ,
      ReportNameEnum.SOKOJ,
      EndpointTypeEnum.Xls
    );

    this.reportService.exportToDocument(payload).subscribe(xlsx => {
      ReportService.downloadBlob(
        xlsx,
        MimeFileType.Xlsx,
        this.getExcelFileName('Izvestaj_za_SOKOJ')
      );
    });
  }

  onToolbarActionPrint() {
    if (!this.orderList.length) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const payload = this.reportService.getPayload(
      this.getFilterString(),
      this.orderList,
      FormCode.MSIZV_SOKOJ,
      ReportNameEnum.SOKOJ,
      EndpointTypeEnum.Pdf
    );

    this.reportService.exportToDocument(payload).subscribe(pdf => {
      ReportService.openBlob(pdf, MimeFileType.Pdf);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-za-sokoj/izvestaj-za-sokoj.component.ts